<template>
    <section class="home-container">
        <MasterPage title="后台用户">
            <div slot="title-icon">
                <Icon type="md-settings" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="80">
                    <Row>
                        <Col span="8">
                            <FormItem label="后台账号：">
                                <Input v-model="select.loginName" placeholder="请输入" />
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <FormItem label="账号名称：">
                                <Input v-model="select.realName" placeholder="请输入" />
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <FormItem label="账号状态：">
                                <Select v-model="select.isLock" @on-change="pageNum = 1" placeholder="请选择">
                                    <Option value="false">启用</Option>
                                    <Option value="true" >禁用</Option>
                                </Select>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="search">
                <Button type="primary" icon="md-add" @click="addModel=true">添加</Button>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindSystemUser">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="addModel" title="新增后台账号" @on-cancel="cancelSystemUser">
            <Form :label-width="80">
                <FormItem label="账号头像：">
                    <Upload
                            ref="uploadImage"
                            multiple
                            type="drag"
                            :format="['jpg','jpeg','png']"
                            accept="image/*"
                            :before-upload="fileBefore"
                            :on-success="fileSuccess"
                            :on-error="fileError"
                            action="food/file/upload">
                        <div :style="{padding:'10px 0',backgroundImage: 'url(\'' + itemAdd.imageUrl + '\')',backgroundSize:'contain',backgroundRepeat:'no-repeat',backgroundPosition: 'center' }">
                            <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                            <p>单击或拖动图片以上传</p>
                        </div>
                    </Upload>
                </FormItem>
                <FormItem label="后台账号：">
                    <Input v-model="itemAdd.loginName" autocomplete="new-password" placeholder="请输入" />
                </FormItem>
                <FormItem label="账号昵称：">
                    <Input v-model="itemAdd.realName" autocomplete="new-password" placeholder="请输入" />
                </FormItem>
                <FormItem label="登录密码：">
                    <Input type="password" autocomplete="new-password"  v-model="itemAdd.password" placeholder="请输入" />
                </FormItem>
                <FormItem label="确认密码：">
                    <Input type="password" autocomplete="new-password" v-model="itemAdd.repassword" placeholder="请输入" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelSystemUser">取消</Button>
                <Button type="primary" size="large" :loading="addLoading" @click="addSystemUser">确定</Button>
            </div>
        </Modal>
        <Modal v-model="updateModel" title="修改后台账号" @on-cancel="cancelSystemUser">
            <Form :label-width="100">
                <FormItem label="账号头像：">
                    <Upload
                            ref="uploadImageUpdate"
                            multiple
                            type="drag"
                            :format="['jpg','jpeg','png']"
                            accept="image/*"
                            :before-upload="fileBefore"
                            :on-success="fileSuccess_update"
                            :on-error="fileError"
                            action="food/file/upload">
                        <div :style="{padding:'10px 0',backgroundImage: 'url(\'' + updateInfoItem.imageUrl + '\')',backgroundSize:'contain',backgroundRepeat:'no-repeat',backgroundPosition: 'center' }">
                            <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                            <p>单击或拖动图片以上传</p>
                        </div>
                    </Upload>
                </FormItem>
                <FormItem label="账号名称：">
                    <Input v-model="updateInfoItem.realName" autocomplete="new-password" placeholder="请输入" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelSystemUser">取消</Button>
                <Button type="primary" size="large" :loading="updateLoading" @click="updateSystemUser">确定</Button>
            </div>
        </Modal>
        <Modal v-model="bindModel" width="692" title="账号绑定角色" @on-cancel="cancelSystemUser">
            <Form :label-width="80">
                <Transfer :data="RoleAllList" :list-style="style" :target-keys="RoleKeys" @on-change="transferChange"></Transfer>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelSystemUser">取消</Button>
                <Button type="primary" size="large" :loading="bindLoading" @click="bindPermissionRole">确定</Button>
            </div>
        </Modal>
        <Modal v-model="bindDoctorModel" width="692" title="账号分配" @on-cancel="cancelSystemUser">
            <Form :label-width="100">
                <FormItem label="分配类型：">
                    <Select v-model="UnBindType" placeholder="请选择">
                        <Option value="医生">医生</Option>
                        <Option value="客服">客服</Option>
                    </Select>
                </FormItem>
                <FormItem v-if="UnBindType === '医生'" label="未绑定医生：">
                    <Select v-model="UnBindDoctorId" placeholder="请选择">
                        <Option v-for="item in UnBindDoctor" :value="item.id" :key="item.id">
                            {{ item.name }}
                        </Option>
                    </Select>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelSystemUser">取消</Button>
                <Button type="primary" size="large" :loading="bindDoctorLoading" @click="unbindSelect">确定</Button>
            </div>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                style:{
                    width:'300px',
                    height:'350px',
                },
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '后台账号',
                        align: 'center',
                        key: 'loginName',
                    },
                    {
                        title: '账号名称',
                        align: 'center',
                        key: 'realName',
                    },
                    {
                        title: '账号角色',
                        align: 'center',
                        render: (h, params) => {
                            if (this.dataList[params.index].roleList.length > 0){
                                let roleList = []
                                this.dataList[params.index].roleList.forEach(function (role) {
                                    roleList.push(h('span', {
                                        style: {
                                            marginRight: '5px'
                                        },
                                    },role.name))
                                })
                                return h('div', roleList)
                            }else{
                                return h('span', '暂未绑定角色')
                            }
                        }
                    },
                    {
                        title: '账号分配',
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.type == null){
                                return h('span', '未分配')
                            }else{
                                return h('span', params.row.type === 'doctor'?'医生':'客服')
                            }
                        }
                    },
                    {
                        title: '账号操作',
                        minWidth: 300,
                        align: 'center',
                        render: (h, params) => {
                            if (this.dataList[params.index].isLock){
                                return h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-unlock',
                                            label:"small",
                                        },
                                        on: {
                                            click: () => {
                                                this.reuseSystemUser_modal(this.dataList[params.index].loginName)
                                            }
                                        }
                                    }, '启用')
                            }else{
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-create',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.updateSystemUser_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '编辑'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'ios-link-outline',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.bindSystemUserRole_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '绑定角色'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-link',
                                            label:"small",
                                            loading:this.findDoctorLoading,
                                            disabled:params.row.type==null?false:true,
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.findDoctorLoading = true
                                                this.bindDoctor_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '账号分配'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            icon:'md-trash',
                                            label:"small",
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteSystemUser_modal(this.dataList[params.index].loginName)
                                            }
                                        }
                                    }, '禁用')
                                ]);
                            }
                        }
                    }
                ],
                dataList: [],
                tableLoading:false,
                RoleAllList:[],
                RoleKeys:[],
                systemUserLoginName:'',
                addModel:false,
                addLoading:false,
                updateModel:false,
                updateLoading:false,
                bindModel:false,
                bindLoading:false,
                findDoctorLoading:false,
                bindDoctorModel:false,
                bindDoctorLoading:false,
                isLock:'false',
                select:{
                    loginName:'',
                    realName:'',
                    isLock:'false',
                },
                pageNum:1,
                pageSize:20,
                pageTotal:0,
                itemAdd:{
                    imageUrl: '',
                    loginName:'',
                    realName:'',
                    password:'',
                    repassword:'',
                },
                updateInfoItem: {},
                UnBindDoctorUser:'',
                UnBindDoctor:[],
                UnBindType:'',
                UnBindDoctorId:'',
            }
        },
        created(){
            this.pageFindSystemUser()
            this.findAllRole()
        },
        methods:{
            fileBefore(file){
                this.$refs.uploadImage.clearFiles()
                this.$refs.uploadImageUpdate.clearFiles()
                if (file.type.substring(0,file.type.indexOf("/")).toLowerCase() != 'image' ) {
                    this.$Message.warning('只能上传图片文件');
                    return false
                }
                if (file.size > 1048576) {
                    this.$Message.warning('图片大小请勿超过1M');
                    return false
                }
                return true
            },
            fileSuccess(response){
                this.$Notice.success({title:'图片上传成功'});
                this.itemAdd.imageUrl = response.data.replace(/\\/g,"/")
            },
            fileSuccess_update(response){
                this.$Notice.success({title:'图片上传成功'});
                this.updateInfoItem.imageUrl = response.data.replace(/\\/g,"/")
            },
            fileError(error){
                this.$Notice.error({title:'图片上传失败',desc: error.message});
            },
            pageChange(value){
                this.pageNum = value
                this.pageFindSystemUser()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            transferChange (newTargetKeys) {
                this.RoleKeys = newTargetKeys;
            },
            findAllRole(){
                this.$http.post('permission/roleList',{
                  isDeleted: false,
                  pageSize:0,
                  pageNum:0,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.RoleAllList = msg.data.list.map((item)=>{return {key:item.id,label:item.name}})
                    }else {
                        this.$Notice.error({title:'角色权限查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            pageFindSystemUser(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('systemUser/list',{
                    loginName:this.select.loginName,
                    realName:this.select.realName,
                    isLock:this.select.isLock,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'后台账号查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            addSystemUser(){
                if (this.itemAdd.imageUrl.length <= 0){
                    return this.$Message.warning('请上传账号图片');
                }
                if (this.itemAdd.loginName.length <= 0){
                    return this.$Message.warning('请输入后台账号');
                }
                if (this.itemAdd.password.length <= 0){
                    return this.$Message.warning('请输入登录密码');
                }
                if (this.itemAdd.password != this.itemAdd.repassword){
                    return this.$Message.warning('两次密码不一致');
                }
                this.addLoading = true
                this.$http.post('systemUser/add',{
                    imageUrl: this.itemAdd.imageUrl,
                    loginName:this.itemAdd.loginName,
                    realName:this.itemAdd.realName,
                    password:this.itemAdd.password
                }).then(function (res) {
                    this.cancelSystemUser()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '后台账号新增成功'});
                        this.pageFindSystemUser()
                    }else {
                        this.$Notice.error({title:'后台账号新增失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelSystemUser()
                    this.myError(res.body)
                })
            },
            updateSystemUser_modal(item){
                this.updateInfoItem = JSON.parse(JSON.stringify(item))
                this.updateModel = true
            },
            updateSystemUser(){
                if (this.updateInfoItem.imageUrl.length <= 0){
                    return this.$Message.warning('请上传账号图片');
                }
                if (this.updateInfoItem.realName.length <= 0){
                    return this.$Message.warning('请输入账号名称');
                }
                this.updateLoading = true
                this.$http.post('systemUser/update',{
                    loginName:this.updateInfoItem.loginName,
                    realName:this.updateInfoItem.realName,
                    imageUrl:this.updateInfoItem.imageUrl
                }).then(function (res) {
                    this.cancelSystemUser()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '后台账号修改成功'});
                        this.pageFindSystemUser()
                    }else {
                        this.$Notice.error({title:'后台账号修改失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelSystemUser()
                    this.myError(res.body)
                })
            },
            cancelSystemUser(){
                this.addModel = this.addLoading = this.updateModel = this.updateLoading = this.bindModel = this.bindLoading = this.bindDoctorModel = this.bindDoctorLoading = false
                this.itemAdd = {
                    imageUrl: '',
                    loginName:'',
                    realName:'',
                    password:'',
                    repassword:'',
                }
            },
            bindSystemUserRole_modal(systemUser){
                if (this.RoleAllList.length <= 0 ) {
                    this.findAllRole()
                }
                this.systemUserLoginName = systemUser.loginName
                this.RoleKeys = systemUser.roleList.map((item) => {return item.id})
                this.bindModel = true
            },
            bindPermissionRole(){
                this.bindLoading = true
                this.$http.post('permission/bindUserRole',{
                    loginName:this.systemUserLoginName,
                    roleIdList:this.RoleKeys.sort(sortNumbers).join(','),
                }).then(function (res) {
                    this.cancelSystemUser()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '账号绑定角色成功'});
                        this.pageFindSystemUser()
                    }else {
                        this.$Notice.error({title:'账号绑定角色失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelSystemUser()
                    this.myError(res.body)
                })
            },
            deleteSystemUser_modal(loginName){
                this.$Modal.confirm({
                    title: '确认禁用账号“'+loginName + '”',
                    loading:true,
                    onOk: () => {
                        this.deleteSystemUser(loginName);
                    }
                });
            },
            deleteSystemUser(loginName){
                this.$http.post('systemUser/delete',{
                    loginName:loginName,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '后台账号禁用成功'});
                        this.pageFindSystemUser()
                    }else {
                        this.$Notice.error({title:'后台账号禁用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            reuseSystemUser_modal(loginName){
                this.$Modal.confirm({
                    title: '确认启用账号“'+loginName + '”',
                    loading:true,
                    onOk: () => {
                        this.reuseSystemUser(loginName);
                    }
                });
            },
            reuseSystemUser(loginName){
                this.$http.post('systemUser/reuse',{
                    loginName:loginName,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '后台账号启用成功'});
                        this.pageFindSystemUser()
                    }else {
                        this.$Notice.error({title:'后台账号启用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            bindDoctor_modal(item){
                this.bindDoctorUser = item
                this.$http.post('doctor/getUnBindDoctor'
                ).then(function (res) {
                    this.findDoctorLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.UnBindDoctor = msg.data
                        this.bindDoctorModel = true
                    }else {
                        this.$Notice.error({title:'未绑定医生列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.findDoctorLoading = false
                    this.myError(res.body)
                })
            },
            unbindSelect () {
                if (this.UnBindType === '') {
                    return this.$Message.warning('请选择分配类型');
                }
                if (this.UnBindType === '医生') {
                    this.bindDoctor()
                } else if (this.UnBindType === '客服') {
                    this.bindCustomerService()
                }
            },
            bindDoctor(){
                if (this.UnBindDoctorId.length <= 0){
                    return this.$Message.warning('请选择未绑定医生');
                }
                this.bindDoctorLoading = true
                this.$http.post('doctor/bind',{
                    doctorId:this.UnBindDoctorId,
                    loginName:this.bindDoctorUser.loginName,
                }).then(function (res) {
                    this.cancelSystemUser()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '分配医生成功'})
                        this.pageFindSystemUser()
                    }else {
                        this.$Notice.error({title:'分配医生失败',desc: msg.message})
                    }
                },function (res) {
                    this.cancelSystemUser()
                    this.myError(res.body)
                })
            },
            bindCustomerService(){
                this.bindDoctorLoading = true
                this.$http.post('systemUser/bindOnlineCustomerService',{
                    loginName:this.bindDoctorUser.loginName,
                }).then(function (res) {
                    this.cancelSystemUser()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '分配客服成功'})
                        this.pageFindSystemUser()
                    }else {
                        this.$Notice.error({title:'分配客服失败',desc: msg.message})
                    }
                },function (res) {
                    this.cancelSystemUser()
                    this.myError(res.body)
                })
            }
        }
    }
    function sortNumbers(a,b){
        return a-b;
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }
</style>
